export default function advisingStudentState({ byUser }, studentUid) {
  return { ...byUser[studentUid], studentUid };
}
